const triggerBeacon = (sdkInstance, app, placement, beacon, handleErrors) => {
  try {
    sdkInstance.triggerBeacon({
      app,
      placement,
      beacon
    });
  } catch (error) {
    handleErrors && handleErrors(error);
  }
};

export default triggerBeacon;
